module.exports = __webpack_public_path__ + "static/media/frontline-5-persona.677c96d5.png";